import { ChatPendingConfirmation } from 'modules/chat/domain/interfaces';
import React from 'react';
import { UDButton } from 'ud-ui/components';

interface Props {
  confirmation: ChatPendingConfirmation;
  disabled?: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => Promise<void>;
}

const ChatConfirmationCard: React.FC<Props> = ({ confirmation, disabled = false, onConfirm, onCancel }) => {
  return (
    <div className="mt-3 flex gap-2" data-confirmation-id={confirmation.confirmationId}>
      <UDButton variant="primary" slim type="button" loading={disabled} disabled={disabled} onClick={onConfirm}>
        Подтвердить
      </UDButton>
      <UDButton variant="secondary" slim type="button" loading={disabled} disabled={disabled} onClick={onCancel}>
        Отмена
      </UDButton>
    </div>
  );
};

export default React.memo(ChatConfirmationCard);
